import React from "react";
import { DataTable } from "@/components/DataTable";
import { EmptyState } from "@/components/DataTable/States/Empty";
import { CalendarClock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useGamesLiveEventsColumns } from "./columns";
import { TableHeader } from "./TableHeader";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";
import { useLiveEventsTable } from "@/pages/GamesAndLiveEventsOverview/hooks/useLiveEventsTable";
import { LiveEventStatusEnum } from "@/__generated__/types";

export const GamesLiveEventsTab = () => {
  const { t } = useTranslation();
  const { navToRoute } = useProtectedNavigation();
  const {
    eventsData,
    loading,
    hasNextPage,
    hasPreviousPage,
    pageIndex,
    pageCount,
    handleFilterApply,
    getFilterDisplayValue,
    handleNextPage,
    handlePreviousPage,
    availableChatChannels,
  } = useLiveEventsTable(LiveEventStatusEnum.Scheduled);
  const columns = useGamesLiveEventsColumns();

  return (
    <div className="space-y-6">
      <div className="max-h-[700px]">
        <DataTable
          data={eventsData}
          columns={columns}
          isLoading={loading}
          pagination={
            <>
              <DataTable.PaginationLabel
                pageCount={pageCount}
                pageIndex={pageIndex}
              />
              <DataTable.PaginationControls
                onNextPage={hasNextPage ? handleNextPage : false}
                onPreviousPage={hasPreviousPage ? handlePreviousPage : false}
              />
            </>
          }
          tableHeader={<DataTable.THeader />}
          tableBody={<DataTable.TBody />}
          emptyState={
            <EmptyState
              copy={t(
                "gamesLiveEvents.communityToolsOverview.tabs.gamesLiveEvents.emptyState",
              )}
              buttonCopy={t(
                "gamesLiveEvents.communityToolsOverview.scheduleNewButton",
              )}
              buttonTarget={() => navToRoute("editEvent")}
              icon={
                <CalendarClock
                  className="h-[36px] w-[36px] text-primary-light"
                  aria-label={t(
                    "gamesLiveEvents.communityToolsOverview.scheduleNewButton",
                  )}
                />
              }
            />
          }
          topHeader={
            <TableHeader
              onFilterChange={handleFilterApply}
              filterDisplayValue={getFilterDisplayValue()}
              availableChatChannels={availableChatChannels}
            />
          }
        />
      </div>
    </div>
  );
};
